import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import VueFileAgent from 'vue-file-agent';
import swal from 'sweetalert';
import 'vue2-datepicker/index.css';
import 'vue-file-agent/dist/vue-file-agent.css';
import mobile from 'is-mobile';
import {debounce} from "lodash";


Vue.use(VueFileAgent);

import TotalSearchMykeyword from "./components/common/total_search_mykeyword";

new Vue({
  el: '#h',
  data: function () {
    return {
      title: '',
      navbarMenu: false,
      v1: false,
      v2: false,
      v3: false,
      v4: false,
      v5: false,
      v6: false,
      v7: false,
      detailProfile: null,
      detail: null,
      // 인기검색어
      popwordList: [],
      // 내가 찾은 검색어
      mywordList: [],
      // 자동 완성
      autowordList: [],
      // 연관 검색어
      recommendList: [],
      // 알림 관련
      showNotificationPopup: false,
      showNotificationSettings: false,
      notificationCount: 0,
      notifications: [],
      // 모바일 알림 팝업
      showMobileNotificationPopup: false,
      showMobileNotificationSettings: false,
      // 알림 설정
      notificationSettingsEnabled: true,
      notificationSettingsTimes: ['morning'],
      pushNotificationEnabled: true,
    }
  },
  computed: {
    // 안 읽은 알림이 있는지 확인
    hasUnreadNotifications() {
      return this.notifications.some(noti => !noti.isRead);
    }
  },
  watch: {
    title(n) {
      this.onChangeTitle(n)
    },
    // 알림 설정 자동 저장
    notificationSettingsEnabled(newVal) {
      this.autoSaveNotificationSettings();
    },
    notificationSettingsTimes: {
      handler() {
        if (this.notificationSettingsEnabled) {
          this.autoSaveNotificationSettings();
        }
      },
      deep: true
    },
    pushNotificationEnabled(newVal) {
      this.autoSaveNotificationSettings();
    }
  },
  created: function () {

  },
  mounted: function () {
    // pageLoad(this);
    this.fnOnLoadInit();
    this.fnGetProfile();
    this.loadNotifications(); // 알림 로딩

    // 팝업 외부 클릭 시 닫기
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy: function() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    navbarBurger: function () {
      this.navbarMenu = true

    },
    /*
    navbarburgerback.addEventListener('click', () => {
        navbarMenu.classList.remove('active');
        navbarOverlay.classList.remove('active');
    });
    */
    navbarOverlay: function () {
      this.navbarMenu = false
    },
    fnOnLoadInit: function () {
      this.loadPopwordList().then() // 인기검색어 로딩
      this.myKeywordLoad(); // 최근 검색어 로딩
      this.loadNotificationSettings(); // 알림 설정 로딩 (시간별 + 푸시)

    },
    getSearch: function () {
      if(this.title == '') {
        swal("검색어를 입력해주세요").then(function() {
          document.querySelector('#search1').focus();
        });
      }
      else {
        TotalSearchMykeyword.addMyKeyword(this.title, 10) // 내가 찾은 검색어 추가

        // if (this.isMobile) { // TODO CHECK :: 통합검색 모바일 대기중이므로 기존 화면 사용
        // location.href = "/customer/expinfo/share/search?title=" + this.title; // 기존 통합검색
        // } else if (location.pathname.indexOf('/customer/expinfo/share/search_exp') > -1) {
        //   location.href = "/customer/expinfo/share/search_exp?title=" + this.title; // 검색엔진 통합검색 페이징
        // } else {
        location.href = "/customer/expinfo/share/search2?title=" + encodeURI(this.title); // 검색엔진 통합검색
      }


      // }
    },
    fnGetProfile: function () {
      let vm = this;
      let param = {};
      // /api/profile/upload
      Axios.all([
        Axios.post("/api/admin/user/detail/profile", param)
      ]).then(Axios.spread((data1) => {
        // output of req.
        vm.detail = data1.data.detailUser;

        vm.detailProfile = (data1.data.detailUser == null || data1.data.detailUser.filenewname == null) ? "" : "/img/" + data1.data.detailUser.filenewname.substring(0, 8) + "/" + data1.data.detailUser.filenewname;

      }));
    }
    ,
    doSearch: function (word) {
      this.title = word
      this.getSearch()
    },
    /** 검색영역 데이터 로딩 */
    loadSearchLayerData: async function () {
      this.loadPopwordList().then() // 인기검색어 로딩
      this.myKeywordLoad(); // 최근 검색어 로딩
    },
    /* 인기검색어 로딩 */
    loadPopwordList: async function () {
      // 조회범위 : D 일 W 주 M 월
      // 20260615 ida 임시 주석
      const ret = await Axios.get("/search/popword.do", {params: {range: 'M'}})
      // console.log("popwordList = ", ret.data?.Data?.Query) // content : "검색광고" count : 1 id : 2 updown : "U"
      // 20260615 ida 임시 주석
      this.popwordList = ret.data?.Data?.Query ?? []
    },
    /*최근 검색어 로딩*/
    myKeywordLoad: function () {
      this.mywordList = TotalSearchMykeyword.getMyKeywordAll()
    },
    /*최근 검색어 하나 삭제*/
    myKeywordDel: function (word) {
      TotalSearchMykeyword.removeMyKeyword(word)
      this.myKeywordLoad();
    },
    /*최근 검색어 전체 삭제*/
    myKeywordRemoveAll: function () {
      TotalSearchMykeyword.removeAllMyKeyword()
      this.myKeywordLoad();
    },

    goToLogin: function (url, serviceName) {
      swal({
        text: serviceName + "는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: true
          }
        }
      }).then(result => {
        if (result) {
          location.href = "/youthnavi/signup/login?returnURI=" + url;
        }
      });
    },
    /* 자동완성 */
    onChangeTitle: debounce(async function (n) {
      // console.log("***" + n)
      // http://localhost:8080/search/ark.do?query=캠프
      // console.log("쿼리 = " + n)
      const ret = await Axios.get("/search/arkSimple.do", {params: {query: n}})
      // console.log(ret)
      this.autowordList = ret.data?.list ?? []
      console.log("this.autowordList = ", this.autowordList)
      // "hkeyword": "<font style='font-size:13px'><font style='color:#CC6633'>1</font>2월</font>",
      // "keyword": "12월",
      // "count": 30,
      // "type": 1,
      // "linkname": "",
      // "linkurl": ""
    }, 300),

    /* 알림 관련 메서드 */
    toggleNotificationPopup: function(event) {
      event.stopPropagation();
      this.showNotificationPopup = !this.showNotificationPopup;
      if (this.showNotificationPopup) {
        this.loadNotifications();
      }
    },
    closeNotificationPopup: function() {
      this.showNotificationPopup = false;
    },
    handleOutsideClick: function(event) {
      const notiBell = document.querySelector('.notification-bell-container');
      if (notiBell && !notiBell.contains(event.target)) {
        this.showNotificationPopup = false;
        this.showNotificationSettings = false;
      }
    },
    loadNotifications: async function() {
      try {
        const response = await Axios.get('/api/noti/list', {
          params: { page: 1, size: 20 }
        });

        if (response.data?.result === 'ok') {
          const list = response.data.list || [];
          this.notifications = list.map(item => {
            const notiType = (item.noti_type || 'general').toLowerCase();
            return {
              id: item.no,
              type: notiType,
              typeLabel: this.getNotificationTypeLabel(notiType),
              message: item.content || item.title || '',
              timeAgo: this.getTimeAgo(item.insertdate),
              formattedDate: this.formatDateTime(item.insertdate),
              isRead: item.read_yn === '1',
              linkUrl: item.link_url || '',
              showMenu: false
            };
          });
          this.notificationCount = response.data.unread || 0;
        } else {
          this.notifications = [];
          this.notificationCount = 0;
        }
      } catch (error) {
        console.log('알림 로딩 오류:', error);
        this.notifications = [];
        this.notificationCount = 0;
      }
    },
    getNotificationTypeLabel: function(type) {
      const labels = {
        'apply': '신청자 알림',
        'approve': '승인 알림',
        'reject': '반려 알림',
        'notice': '공지사항',
        'event': '이벤트',
        'general': '알림'
      };
      return labels[type] || '알림';
    },
    getNotificationTagClass: function(type) {
      const classes = {
        'apply': 'bg-green-100 text-green-700',
        'approve': 'bg-blue-100 text-blue-700',
        'reject': 'bg-red-100 text-red-700',
        'notice': 'bg-yellow-100 text-yellow-700',
        'event': 'bg-purple-100 text-purple-700',
        'general': 'bg-gray-100 text-gray-700'
      };
      return classes[type] || 'bg-gray-100 text-gray-700';
    },
    getTimeAgo: function(dateString) {
      if (!dateString) return '';
      const now = new Date();
      const date = new Date(dateString);
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);

      if (diffMins < 1) return '방금 전';
      if (diffMins < 60) return diffMins + '분 전';
      if (diffHours < 24) return diffHours + '시간 전';
      if (diffDays < 7) return diffDays + '일 전';
      return String(dateString).substring(0, 10);
    },
    formatDateTime: function(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return year + '-' + month + '-' + day + '  ' + hours + ':' + minutes;
    },
    goToNotification: function(noti) {
      // 읽음 처리 API 호출
      if (!noti.isRead) {
        Axios.post('/api/noti/read', null, { params: { no: noti.id } }).catch(() => {});
        noti.isRead = true;
        this.notificationCount = Math.max(0, this.notificationCount - 1);
      }
      // 해당 페이지로 이동
      if (noti.linkUrl) {
        location.href = noti.linkUrl;
      }
      this.closeNotificationPopup();
    },
    toggleNotificationMenu: function(index) {
      // 다른 메뉴는 모두 닫고 현재 메뉴만 토글
      this.notifications.forEach((noti, i) => {
        if (i === index) {
          noti.showMenu = !noti.showMenu;
        } else {
          noti.showMenu = false;
        }
      });
    },
    deleteNotification: async function(noti, index) {
      try {
        const response = await Axios.post('/api/noti/delete', null, {
          params: { no: noti.id }
        });

        if (response.data?.result === 'ok') {
          // 알림 목록에서 제거
          this.notifications.splice(index, 1);

          // 안 읽은 알림이었다면 카운트 감소
          if (!noti.isRead) {
            this.notificationCount = Math.max(0, this.notificationCount - 1);
          }

          // 성공 메시지 (선택사항)
          // swal('알림이 삭제되었습니다.', '', 'success');
        }
      } catch (error) {
        console.log('알림 삭제 오류:', error);
        // swal('알림 삭제에 실패했습니다.', '', 'error');
      }
    },
    markAllAsRead: async function() {
      try {
        const response = await Axios.post('/api/noti/read-all');

        if (response.data?.result === 'ok') {
          // 모든 알림을 읽음 처리
          this.notifications.forEach(noti => {
            noti.isRead = true;
          });

          // 안 읽은 알림 카운트를 0으로
          this.notificationCount = 0;
        }
      } catch (error) {
        console.log('모두 읽음 처리 오류:', error);
      }
    },
    openNotificationSettings: function() {
      this.showNotificationPopup = false;
      this.showNotificationSettings = true;
    },
    closeNotificationSettings: function() {
      this.showNotificationSettings = false;
    },
    normalizeNotificationTimes: function(rawTimes) {
      const timeAliases = {
        '09:00': 'morning',
        '12:00': 'noon',
        '17:00': 'evening'
      };
      const allowedTimes = ['morning', 'noon', 'evening'];
      const timeList = Array.isArray(rawTimes) ? rawTimes : String(rawTimes || '').split(',');

      return timeList
        .map(time => String(time).trim())
        .map(time => timeAliases[time] || time)
        .filter(time => allowedTimes.includes(time));
    },
    loadNotificationSettings: function() {
      // 알림 설정 로딩 (시간별 + 푸시)
      Axios.get('/api/noti/notification/settings').then((response) => {
        if (response.data.result === 'ok') {
          const settings = response.data.settings;

          // 푸시 설정 반영
          this.pushNotificationEnabled = settings.pushEnabled;

          const rawTimes = settings.notification_times || settings.notification_time || 'morning';
          const normalizedTimes = this.normalizeNotificationTimes(rawTimes);
          this.notificationSettingsTimes = normalizedTimes.length ? normalizedTimes : ['morning'];

          if (settings.batchActive === undefined || settings.batchActive === null) {
            this.notificationSettingsEnabled = this.notificationSettingsTimes.length > 0;
          } else {
            this.notificationSettingsEnabled = settings.batchActive === true || settings.batchActive === 'Y';
          }

          // console.log('알림 설정 로딩 완료:', settings, 'times:', this.notificationSettingsTimes);
        }
      }).catch((error) => {
        // console.log('알림 설정 로딩 실패:', error);
      });
    },
    autoSaveNotificationSettings: function() {
      // 설정 변경 시 자동 저장 (시간별 또는 푸시)
      const payload = {};

      // 푸시 설정 포함
      payload.pushEnabled = this.pushNotificationEnabled;
      payload.enabled = this.notificationSettingsEnabled;

      const selectedTimes = this.normalizeNotificationTimes(this.notificationSettingsTimes);
      if (selectedTimes.length > 0) {
        payload.notification_time = selectedTimes.join(',');
      }

      // 시간별 설정 값 포함 (복수 선택 가능)
      Axios.post('/api/noti/notification/settings', payload).then(() => {
        console.log('알림 설정 자동 저장 완료');
      }).catch(() => {
        console.log('알림 설정 자동 저장');
      });
    },
    /* 모바일 알림 팝업 관련 메서드 */
    openMobileNotificationPopup: function() {
      this.showMobileNotificationPopup = true;
      this.loadNotifications();
      // body 스크롤 방지
      document.body.style.overflow = 'hidden';
    },
    closeMobileNotificationPopup: function() {
      this.showMobileNotificationPopup = false;
      // body 스크롤 복원
      document.body.style.overflow = '';
    },
    openMobileNotificationSettings: function() {
      this.showMobileNotificationPopup = false;
      this.showMobileNotificationSettings = true;
    },
    closeMobileNotificationSettings: function() {
      this.showMobileNotificationSettings = false;
      this.showMobileNotificationPopup = true;
    }
  }
});
